var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.7422V12.4922C13.125 12.9748 12.7326 13.3672 12.25 13.3672H1.75C1.26744 13.3672 0.875 12.9748 0.875 12.4922V10.7422C0.875 10.5007 1.071 10.3047 1.3125 10.3047C1.554 10.3047 1.75 10.5007 1.75 10.7422V12.4922H12.25V10.7422C12.25 10.5007 12.446 10.3047 12.6875 10.3047C12.929 10.3047 13.125 10.5007 13.125 10.7422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6283 7.5515C3.45723 7.38044 3.45723 7.10394 3.6283 6.93287C3.79936 6.76181 4.07586 6.76181 4.24692 6.93287L6.56261 9.24856V1.55469C6.56261 1.31319 6.75861 1.11719 7.00011 1.11719C7.24161 1.11719 7.43761 1.31319 7.43761 1.55469V9.24856L9.7533 6.93287C9.92436 6.76181 10.2009 6.76181 10.3719 6.93287C10.543 7.10394 10.543 7.38044 10.3719 7.5515L7.30942 10.614C7.13617 10.7877 6.85836 10.782 6.69036 10.614L3.6283 7.5515Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.858f469b70191d5fab55981669874064.svg";
export { ForwardRef as ReactComponent };